import { render, staticRenderFns } from "./SampleWebsocket.vue?vue&type=template&id=3845f916&scoped=true&"
import script from "./SampleWebsocket.vue?vue&type=script&lang=js&"
export * from "./SampleWebsocket.vue?vue&type=script&lang=js&"
import style0 from "./SampleWebsocket.vue?vue&type=style&index=0&id=3845f916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3845f916",
  null
  
)

export default component.exports